module.exports = __webpack_public_path__ + "a17d279f/img/link-icon.fa09ed66.svg";